/**
 * 判断是否HTML元素
 * @return {Boolean} 是否HTML元素
 */
const isElement = function(o: any): boolean {
  return o instanceof Element || o instanceof HTMLDocument;
};
export default isElement;
